module.exports = __webpack_public_path__ + "img/whatsapp-blue.af7e160a.svg";